export const menuBtnStyles = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  padding: "12px",
  borderRadius: "8px",
  color: "#3E3F4C",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "22px",
  textTransform: "none",
  minWidth: "auto",

  ":hover": { backgroundColor: "#0000000D" },
};

export const menuStyles = {
  "& .MuiPaper-root": {
    borderRadius: "12px",
    boxShadow: "0px 2px 10px 0px #00000029",
    backgroundColor: "#FFFFFF",
    padding: "12px",
    marginTop: "8px",
  },
  "& .MuiMenu-list": {
    padding: 0,
  },
  "& .MuiMenuItem-root": {
    padding: "8px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "8px",
    color: "#3E3F4C",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "22px",
    "&:hover": {
      backgroundColor: "#0000000D",
    },
  },
};
